module.exports = __webpack_public_path__ + "static/img/img10.c1f6b17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/shop/img10.jpg
// module id = aZE9
// module chunks = 0